<script>
import { mapGetters } from "vuex"
export default {
  data: function () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'IsProLevelSystem'
    ])
  },
  created: function () {

  },
  methods: {
    getBadgeClassName (payType, oldName) {
      let className = '';
      const isProLevelSystem = this.IsProLevelSystem
      if (isProLevelSystem) {
        if (payType === 4) {
          className = 'proPlus';
        }
        if (payType === 6) {
          className = 'pro';
        }
      }
      if (!className) {
        className = oldName;
      }
      return className;
    },
    getOptionName(payType) {
      if (payType === 4) {
        return this.IsProLevelSystem ? '动画Pro+版会员专属' : '臻享会员专属'
      }
      return this.IsProLevelSystem ? '动画Pro版会员专属' : '会员专属'
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/mixins/vipBadge.vue